

































































































































import PersonaService, { PersonaDto } from "@/api/PersonaService";
import AuthStore from "@/store/modules/AuthStore";
import Valid from "@/utils/valid";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      basePerson: {
        id: "",
        nombre: "",
        apellido: "",
        tipoIdentificacion: "CED",
        identificacion: 9999999999,
        fechaNacimiento: "2015-01-01",
        sexo: "M"
      },
      person: {} as PersonaDto,

      data: [],

      birthdateModal: false,
      loading: false,
      validForm: null,

      identityNumberRules: null,
      identityTypeOptions: [
        { text: "Cédula", value: "CED" },
        { text: "Pasaporte", value: "PAS" },
      ],
      genreOptions: [
        { text: "Masculino", value: "M" },
        { text: "Femenino", value: "F" },
      ],
      headers: [
        { text: "Id", value: "id" },
        { text: "Nombre", value: "nombre" },
        { text: "Apellido", value: "apellido" },
        { text: "Cedula", value: "identificacion" },
        { text: "Fecha de nacimiento", value: "fechaNacimiento" }
      ],

      requiredRule: [(v: string) => !!v || "Campo requerido"],
    };
  },
  mounted() {
    this.loadDependants();
  },
  methods: {
    loadDependants() {
      PersonaService.getDependants().then((response) => {
        this.data = response.data;
      });
    },
    async sendForm() {
      const isValid = (this.$refs.form as Vue & {
        validate: () => boolean;
      }).validate();

      if (this.validForm) {
        PersonaService.createDependant(AuthStore.getPersonaID, {
          ...this.person,
        })
          .then((a) => {
            this.loadDependants();
            this.person = { ...this.basePerson };
            this.$refs.form.reset();
            this.$swal({
              toast: true,
              position: "bottom-right",
              showConfirmButton: false,
              timer: 3000,
              icon: "success",
              title: "Mensaje",
              text: "Registro creado exitosamente"
            });
          })
          .catch((e) => {
            this.$swal({
              toast: true,
              position: "bottom-right",
              showConfirmButton: false,
              timer: 1500,
              icon: "error",
              title: "Mensaje",
              text: "No se pudo crear el dependiente"
            });
          });
      }
    },
    getMaxDate() {
      const today = new Date();
      const endDate = new Date(
        today.getFullYear() - 2,
        today.getMonth(),
        today.getDate()
      );
      return endDate.toISOString().slice(0, 10);
    },
    getIdentityNumberRules(): any {
      switch (this.person.tipoIdentificacion) {
        case "CED":
          return [
            ...this.requiredRule,
            (v: string) =>
              (v?.length === 10 && Valid.identificacionValida(v)) ||
              "La cédula no es válida"
          ];
        case "RUC":
          return [
            ...this.requiredRule,
            (v: string) =>
              (v?.length === 13 && Valid.identificacionValida(v)) ||
              "El RUC no es válido"
          ];
        default:
          return this.requiredRule;
      }
    },
  },
});
